import React from "react";
import { Page, Text, View, Document, StyleSheet } from "@react-pdf/renderer";

// Estilos mejorados del PDF
const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    padding: 20,
    fontSize: 10,
    backgroundColor: "#f8f8f8",
  },
  title: {
    fontSize: 18,
    textAlign: "center",
    marginBottom: 10,
    fontWeight: "bold",
    color: "#333",
  },
  section: {
    marginBottom: 10,
    paddingBottom: 5,
    borderBottom: "1px solid #000",
  },
  table: {
    display: "table",
    width: "100%",
    marginBottom: 10,
    borderCollapse: "collapse",
  },
  row: {
    flexDirection: "row",
    borderBottom: "1px solid #ccc",
  },
  headerRow: {
    flexDirection: "row",
    backgroundColor: "#00BF63",
    color: "white",
    fontWeight: "bold",
  },
  cell: {
    padding: 6,
    flex: 1,
    textAlign: "center",
    borderRight: "1px solid #ccc",
  },
  headerCell: {
    padding: 6,
    flex: 1,
    textAlign: "center",
    fontWeight: "bold",
    borderRight: "1px solid white",
  },
  alternateRow: {
    backgroundColor: "#f2f2f2",
  },
});

// Mapeo de números a días de la semana
const diasSemana = {
  1: "Lunes",
  2: "Martes",
  3: "Miércoles",
  4: "Jueves",
  5: "Viernes",
};

const HorarioPDF = ({ horarios }) => {
  return (
    <Document>
      <Page size="LETTER" style={styles.page}>
        <Text style={styles.title}>Horarios</Text>

        {/* Tabla */}
        <View style={styles.table}>
          {/* Encabezado */}
          <View style={styles.headerRow}>
            <Text style={styles.headerCell}>Hora Inicio</Text>
            <Text style={styles.headerCell}>Hora Fin</Text>
            <Text style={styles.headerCell}>Día</Text>
            <Text style={styles.headerCell}>Asignatura</Text>
            <Text style={styles.headerCell}>Profesor</Text>
            <Text style={styles.headerCell}>Aula</Text>
          </View>

          {/* Filas de horarios con estilo alterno */}
          {horarios && horarios.length > 0 ? (
            horarios.map((horario, index) => (
              <View
                key={horario.id}
                style={[
                  styles.row,
                  index % 2 === 0 ? styles.alternateRow : null,
                ]}
              >
                <Text style={styles.cell}>{horario.hora_inicio}</Text>
                <Text style={styles.cell}>{horario.hora_fin}</Text>
                <Text style={styles.cell}>
                  {diasSemana[horario.dia] || "Desconocido"}
                </Text>
                <Text style={styles.cell}>{horario.asignatura}</Text>
                <Text style={styles.cell}>
                  {horario.usuario_nombre} {horario.usuario_apellido_paterno} {horario.usuario_apellido_materno}
                </Text>
                <Text style={styles.cell}>{horario.aula_nombre}</Text>
              </View>
            ))
          ) : (
            <Text style={{ textAlign: "center", marginTop: 10 }}>
              No hay horarios disponibles.
            </Text>
          )}
        </View>
      </Page>
    </Document>
  );
};

export default HorarioPDF;